import React, { useEffect, useState, useRef} from "react";
import { Header, Sidebar } from "../Layout";
// import { Loading } from "../shared";
import { Link, useHistory} from "react-router-dom";
import { getMembers, memberUpdate, destroyMembers} from "../../actions/memberActions";
import { useSelector, useDispatch } from "react-redux";
import DataTablesMembers from "./DataTablesMembers";
import AddMemberModal from "./AddMemberModal";
import { MEMBER } from '../../constants/constants';

const Members = () => {

    const { members } = useSelector(state=> state.memberStore);
    const { user} = useSelector(state=> state.auth);
    const dispatch = useDispatch();
    const history  = useHistory();
    // const [inputProjectData, setProjectData] = useState()
    const [showAddAdminModal, setAddAdminModal] = useState(false);
	const [selectedRowData, setselectedRowData] = useState(false);
	const [inputActionIds, setActionIds] = useState(null);
	// const [inputAdminData, setAdminData] = useState("");
	// const [inputSelectedCount, setSelectedCount] = useState(0);
	const childRef = useRef();
 
    useEffect(() => {
        if (user.userType === MEMBER) history.push('/')
        dispatch(getMembers());
    }, [user, dispatch, history])

    // useEffect(() => {
    //     setProjectData(members)
    // }, [members])

    const handleAddAdminClose = () => {
		setAddAdminModal(false);
		setselectedRowData(false);
	};

    const handleAddMemberShow = () => {
		setselectedRowData(false);
        setAddAdminModal(true);
    };
	const selectedData = (data) => {
		setselectedRowData(data);
		setActionIds([data.userId]);
		setAddAdminModal(true);
	};
	
    const handleSubmitBlockUnblock = (userStatus) => {
        console.log(userStatus ,'change status');
        const updateData ={
            id: userStatus.userId,
            first_name: userStatus.first_name,
            last_name: userStatus.last_name,
            email: userStatus.email,
            contact_no: userStatus.contact_no,
            designation: userStatus.designation,
            is_blocked: userStatus.status  ? false : true ,
        };
        dispatch(memberUpdate(updateData))
    }
	
	const  setSelectedRowsCount = (newCount) => {
		// setSelectedCount(newCount);
	};
	const  deleteAdminData = async() => {
        if (inputActionIds && inputActionIds.length ) {
            var element;
            for (let index = 0; index < inputActionIds.length; index++) {
                element = inputActionIds[index];
            }
            //console.log("inputActionIds", element);
		    dispatch(destroyMembers(element));
			handleAddAdminClose();
		} else {
			alert("Please select any member");
		}
	};
	
    // if (loading) {
    //     return (
    //         <Loading/>
    //     );
    // }
	
    const findRows = (rows) => {
		setActionIds(rows);
		console.log("checked rows", inputActionIds);
	};
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Members</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Members</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix py-3">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                                <h3 className="text-bold"><strong>Members</strong></h3>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 text-right">
                            <button onClick={() => handleAddMemberShow()} className="header-dropdown dropdown dropdown-animated scale-left btn button text-right text-white"><i className="fa fa-plus-circle mr-2"></i>New Member</button>
                        </div>
                    </div>
                    <div className="row clearfix">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded">
                                   
                                </div>
                                <div className="body text-center card-body-shadow">
                                    <DataTablesMembers ref={childRef} data={members} openModal={selectedData} changeStatus={handleSubmitBlockUnblock} mode='edit'  change={findRows} countRows={setSelectedRowsCount} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddMemberModal
                open={showAddAdminModal}
                close={handleAddAdminClose}
                data={selectedRowData}
                onLoad={members}
                deleteData={deleteAdminData}
            />
        </>
    )
}

export default Members;